var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlippedButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#BBBBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89171 14.3508C10.3727 11.082 13.4125 8.82209 16.6813 9.30311C17.7966 9.46721 18.8428 9.94308 19.6994 10.6759L18.9282 11.447C18.6698 11.7055 18.6698 12.1246 18.9284 12.3831C19.0525 12.5071 19.2208 12.5769 19.3962 12.5769H22.4318C22.7974 12.5769 23.0937 12.2806 23.0937 11.915V8.87943C23.0936 8.51387 22.7972 8.21759 22.4316 8.21765C22.2562 8.21768 22.0879 8.2874 21.9638 8.41144L21.1033 9.27193C17.8218 6.34682 12.7904 6.63569 9.86527 9.91714C8.82899 11.0796 8.1565 12.5206 7.93112 14.0616C7.84226 14.6079 8.21307 15.1228 8.75933 15.2116C8.80854 15.2196 8.85825 15.2239 8.90811 15.2246C9.4079 15.2192 9.82742 14.8465 9.89171 14.3508Z",
    fill: "#535353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7168 15.2246C22.217 15.23 21.7975 15.6027 21.7332 16.0983C21.2522 19.3671 18.2123 21.6271 14.9436 21.1461C13.8283 20.982 12.7821 20.5061 11.9255 19.7733L12.6966 19.0022C12.9551 18.7437 12.955 18.3246 12.6965 18.0661C12.5724 17.942 12.4041 17.8723 12.2287 17.8723H9.19316C8.82759 17.8723 8.53125 18.1686 8.53125 18.5342V21.5698C8.53134 21.9353 8.82775 22.2316 9.19331 22.2315C9.36877 22.2315 9.53706 22.1618 9.66114 22.0378L10.5216 21.1773C13.8023 24.1027 18.8334 23.8147 21.7588 20.534C22.7956 19.3713 23.4684 17.9298 23.6938 16.3883C23.783 15.8421 23.4125 15.3269 22.8663 15.2377C22.8169 15.2296 22.7669 15.2252 22.7168 15.2246Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlippedButton);
export default __webpack_public_path__ + "static/media/flipped-button.500f0e72923358b952e1cbd21d567bcd.svg";
export { ForwardRef as ReactComponent };